module.exports = __webpack_public_path__ + "fonts/fa-solid-900.8a8c0474.woff2";